import React from "react"
import { graphql } from "gatsby"

import { SEO } from "../components"
import Layout from "../components/layout"

const About = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title
  const [about] = data.allMarkdownRemark.nodes

  return (
    <Layout location={location} title={siteTitle}>
      <SEO title="About" description={about.frontmatter.description} />
      <article>
        <header>
          <h2>{about.frontmatter.title}</h2>
        </header>
        <section id="about" dangerouslySetInnerHTML={{ __html: about.html }} />
      </article>
    </Layout>
  )
}

export default About

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(filter: { frontmatter: { type: { eq: "about" } } }) {
      nodes {
        html
        frontmatter {
          title
          description
        }
      }
    }
  }
`
